import { Tabs, Tab, Button, Chip, Popover, PopoverContent, Autocomplete, AutocompleteItem, PopoverTrigger, } from "@nextui-org/react"
import { MainContainer } from "../../components/index.js"
import DashboardChart from "./DashboardChart.jsx"
import DashboardPurchase from "./DashboardPurchase.jsx"
import DashboardSale from "./DashboardSale.jsx"
import DashboardOutstanding from "./DashboardOutstanding.jsx"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { apiRoute, ENUM_ENCRYPT_CODE, linksUrl } from "../../constants/enum.js"
import { isMobile } from "react-device-detect"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar, faCalendarAlt, faCalendarDays, faCalendarXmark, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import Temp from "./newdash/Temp.jsx"
import { DashboardPartywiseOutstanding } from "./DashboardPartywiseOutstanding.jsx"



function Dashboard() {
  const { rcid } = useParams();
  const [isDateDisable, setIsDateDisable] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("")

  const { compCode, yearId, isReload, startDate, endDate } = useSelector((state) => state.company)
  const [filterDate, setFilterDate] = useState({
    start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
    end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
  })
  const [propsDate, setPropsDate] = useState({
    start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
    end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
  })
  const { data: unitMaster = [] } = useFetchWithBody({
    url: apiRoute.report.invoice.getUnit,
    queryKey: "Fetch Unit data",
    inputData: {
      compcode: compCode.join(",")
    }
  })
  let tabs = [
    {
      id: "chart",
      label: "Chart",
      content: <DashboardChart propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "purchase",
      label: "Purchase",
      content: <DashboardPurchase propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "sale",
      label: "Sale",
      content: <DashboardSale propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "outstanding",
      label: "Outstanding",
      content: <DashboardOutstanding />,
    },
    {
      id: "partywiseoutstanding",
      label: "Party Wise OutStanding",
      content: <DashboardPartywiseOutstanding />
    }
  ]

  //set payable recevable when click from main dashboard
  let isRedFrmDsbMst = ""
  if (rcid == ENUM_ENCRYPT_CODE.payable || rcid == ENUM_ENCRYPT_CODE.receivable || rcid == ENUM_ENCRYPT_CODE.difference
    || rcid == ENUM_ENCRYPT_CODE.purchase || rcid == ENUM_ENCRYPT_CODE.sale
  )
    isRedFrmDsbMst = rcid ?? ""

  const outPData = useSelector((state) => state.outstandingPayable)
  const outRData = useSelector((state) => state.outstandingReceivable)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterDate(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleReset = () => {
    setFilterDate({
      start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })
    setPropsDate({
      start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })

  }
  const handleBtnClick = () => {
    let error = ""
    const start = dayjs(filterDate.end)
    const end = dayjs(filterDate.start)
    const months = start.diff(end, 'month');
    const t_year = dayjs(startDate).format('YYYY')
    const minDate = t_year - 2 + "-" + dayjs(startDate).format('MM') + "-" + dayjs(startDate).format('DD')

    if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
      filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
      filterDate.start == null || filterDate.end == null) {
      toast.error("Inavlid Start / End Date ", {
        "position": "top-center"
      })

    }
    else {
      if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

        }
      }
      if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

        }
      }
    }
    if (months > 12) error += "Date period must not be greater than 1 year,"
    if (error == "") {
      //console.log(filterDate)
      setPropsDate(filterDate)
    }
    else {
      const messages = error.split(',');
      toast.error(
        <div>
          {messages.map((msg, idx) => msg != "" ? (

            <div key={idx} className="p-1">
              <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
              {msg.trim()}</div> // Trim to remove extra spaces
          ) : "")}
        </div>,
        {
          position: "top-center",
          icon: false,
          style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
        }
      );
    }
    //e.preventDefault();

  }
  const handleTabChange = (val) => {

    if (["outstanding","partywiseoutstanding"].includes(val)) {
      setIsDateDisable(true)
    }
    else
      setIsDateDisable(false)
  }
  const defaultSelectedKey =
    outPData?.isFromDashboard || outRData?.isFromDashboard ||
      (isRedFrmDsbMst &&
        (isRedFrmDsbMst === ENUM_ENCRYPT_CODE.receivable ||
          isRedFrmDsbMst === ENUM_ENCRYPT_CODE.payable))
      ? "outstanding"
      : isRedFrmDsbMst && rcid === ENUM_ENCRYPT_CODE.sale
        ? "sale"
        : isRedFrmDsbMst && rcid === ENUM_ENCRYPT_CODE.purchase
          ? "purchase"
          : undefined;


  return (
    <div>
      <MainContainer pageName="Trading Dashboard" breadcrumbs={[" ", "Trading Dashboard"]}>
        <div>
          {!isDateDisable && (
            <div
              className="
        mb-2
        flex flex-wrap items-center justify-end gap-2
        rounded-xl
        border border-slate-200
        bg-gradient-to-r from-white via-slate-50 to-sky-50/70
        px-3 py-2
        shadow-sm
        dark:border-slate-700
        dark:bg-slate-900
      "
            >

              {/* ==================== UNIT ==================== */}
              <Autocomplete
                size="sm"
                color="primary"
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder="Select Unit"
                className="w-full sm:w-56 md:w-60 font-medium text-sm"
                isClearable={true}
                variant="flat"
                isVirtualized
                defaultItems={unitMaster || []}
                onSelectionChange={setSelectedUnit}
                selectedKey={selectedUnit}
                classNames={{
                  base: "w-full sm:w-56 md:w-60",

                  inputWrapper: `
            h-9
            rounded-lg
            border border-slate-200
            bg-white
            shadow-sm
            transition-all duration-200

            hover:border-indigo-300
            hover:bg-indigo-50/30

            data-[focus=true]:border-indigo-500
            data-[focus=true]:bg-white
            data-[focus=true]:shadow-sm

            dark:border-slate-700
            dark:bg-slate-800
            dark:hover:border-indigo-500
          `,

                  input: `
            text-sm
            font-semibold
            text-slate-700
            dark:text-slate-200
          `,

                  clearButton: `
            text-slate-400
            hover:text-indigo-500
          `,
                }}
              >
                {(list) => (
                  <AutocompleteItem key={list.Party_Id}>
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>


              {/* ==================== DATE RANGE ==================== */}
              <div
                className="
          flex h-9 items-center
          overflow-hidden
          rounded-lg
          border border-slate-200
          bg-white
          shadow-sm
          dark:border-slate-700
          dark:bg-slate-800
        "
              >

                {/* FROM */}
                <div
                  className="
            flex h-full items-center gap-1.5
            px-2.5
            text-xs
            whitespace-nowrap
          "
                >
                  <span className="font-bold text-emerald-600 dark:text-emerald-400">
                    From
                  </span>

                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                    {dayjs(filterDate.start).format("DD-MMM-YYYY")}
                  </span>
                </div>


                {/* Divider */}
                <div className="h-5 w-px bg-slate-200 dark:bg-slate-600" />


                {/* TO */}
                <div
                  className="
            flex h-full items-center gap-1.5
            px-2.5
            text-xs
            whitespace-nowrap
          "
                >
                  <span className="font-bold text-rose-500 dark:text-rose-400">
                    To
                  </span>

                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                    {dayjs(filterDate.end).format("DD-MMM-YYYY")}
                  </span>
                </div>

              </div>


              {/* ==================== CALENDAR ==================== */}
              <Popover
                placement="bottom-end"
                variant="bordered"
                shouldCloseOnBlur={false}
                shouldBlockScroll={true}
                shouldCloseOnScroll={false}
                showArrow={true}
              >
                <PopoverTrigger>
                  <Button
                    size="sm"
                    isIconOnly
                    aria-label="Select date range"
                    className="
              group
              h-9 w-9 min-w-9
              rounded-lg

              border-2 border-violet-200
              bg-violet-50
              text-violet-600

              shadow-sm

              transition-all duration-200

              hover:-translate-y-0.5
              hover:border-violet-500
              hover:bg-violet-600
              hover:text-white
              hover:shadow-md
              hover:shadow-violet-300/40

              active:scale-95

              dark:border-violet-800
              dark:bg-violet-950/40
              dark:text-violet-400

              dark:hover:border-violet-500
              dark:hover:bg-violet-600
              dark:hover:text-white
            "
                  >
                    <FontAwesomeIcon
                      icon={faCalendarDays}
                      className="
                text-lg
                transition-transform duration-200
                group-hover:scale-110
              "
                    />
                  </Button>
                </PopoverTrigger>


                {/* ==================== POPUP ==================== */}
                <PopoverContent
                  className="
            z-[1000]
            overflow-hidden
            rounded-xl
            border border-slate-200
            bg-white
            p-0
            shadow-2xl

            dark:border-slate-700
            dark:bg-slate-900
          "
                >
                  <div
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >

                    {/* ==================== POPUP HEADER ==================== */}
                    <div
                      className="
                border-b border-slate-200
                bg-gradient-to-r
                from-slate-50
                to-violet-50/60
                px-4 py-2.5

                dark:border-slate-700
                dark:from-slate-800
                dark:to-violet-950/30
              "
                    >
                      <div className="flex items-center gap-2.5">

                        {/* Icon */}
                        <div
                          className="
                    flex h-8 w-8
                    items-center justify-center
                    rounded-lg
                    bg-violet-100
                    text-violet-600
                    shadow-sm

                    dark:bg-violet-950/60
                    dark:text-violet-400
                  "
                        >
                          <FontAwesomeIcon
                            icon={faCalendarDays}
                            className="text-sm"
                          />
                        </div>

                        {/* Title */}
                        <div>
                          <p
                            className="
                      text-sm
                      font-bold
                      text-slate-800
                      dark:text-white
                    "
                          >
                            Date Range
                          </p>

                          <p
                            className="
                      text-[10px]
                      text-slate-500
                      dark:text-slate-400
                    "
                          >
                            Select reporting period
                          </p>
                        </div>

                      </div>
                    </div>


                    {/* ==================== POPUP BODY ==================== */}
                    <div
                      className={`
                flex gap-3 p-4
                ${isMobile ? "flex-wrap justify-center" : ""}
              `}
                    >

                      {/* FROM DATE */}
                      <div className="flex flex-col gap-1">

                        <label
                          className="
                    text-[11px]
                    font-semibold
                    text-slate-500
                    dark:text-slate-400
                  "
                        >
                          From Date
                        </label>

                        <input
                          type="date"
                          name="start"
                          value={filterDate.start}
                          onChange={handleChange}
                          required
                          className="
                    h-9
                    rounded-lg
                    border border-slate-200
                    bg-slate-50
                    px-2
                    text-sm
                    font-medium
                    text-slate-700
                    outline-none

                    transition-all

                    focus:border-emerald-500
                    focus:bg-white
                    focus:ring-2
                    focus:ring-emerald-100

                    dark:border-slate-700
                    dark:bg-slate-800
                    dark:text-slate-200
                  "
                        />

                      </div>


                      {/* TO DATE */}
                      <div className="flex flex-col gap-1">

                        <label
                          className="
                    text-[11px]
                    font-semibold
                    text-slate-500
                    dark:text-slate-400
                  "
                        >
                          To Date
                        </label>

                        <input
                          type="date"
                          name="end"
                          value={filterDate.end}
                          onChange={handleChange}
                          required
                          className="
                    h-9
                    rounded-lg
                    border border-slate-200
                    bg-slate-50
                    px-2
                    text-sm
                    font-medium
                    text-slate-700
                    outline-none

                    transition-all

                    focus:border-rose-500
                    focus:bg-white
                    focus:ring-2
                    focus:ring-rose-100

                    dark:border-slate-700
                    dark:bg-slate-800
                    dark:text-slate-200
                  "
                        />

                      </div>


                      {/* ==================== ACTIONS ==================== */}
                      <div className="flex items-end gap-2">

                        {/* APPLY */}
                        <Button
                          size="sm"
                          className="
                    h-8
                    rounded-lg
                    bg-emerald-600
                    px-4
                    font-semibold
                    uppercase
                    tracking-wide
                    text-white

                    shadow-sm

                    transition-all duration-200

                    hover:bg-emerald-700
                    hover:shadow-md
                    active:scale-95
                  "
                          onPress={handleBtnClick}
                        >
                          Apply
                        </Button>


                        {/* RESET */}
                        <Button
                          size="sm"
                          variant="flat"
                          className="
                    h-8
                    rounded-lg
                    bg-slate-100
                    px-4
                    font-semibold
                    uppercase
                    tracking-wide
                    text-slate-600

                    transition-all duration-200

                    hover:bg-slate-200
                    hover:text-slate-800
                    active:scale-95

                    dark:bg-slate-800
                    dark:text-slate-300
                    dark:hover:bg-slate-700
                  "
                          onPress={handleReset}
                        >
                          Reset
                        </Button>

                      </div>

                    </div>
                  </div>
                </PopoverContent>
              </Popover>

            </div>
          )}
        </div>
        {/* <div>
          {isDateDisable ? "" :
            <div className="flex justify-end  flex-wrap items-center gap-2">
              <Autocomplete
                size="sm"
                label={""}
                color="danger"
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--SELECT UNIT--"}
                className="w-60 font-semibold text-sm"
                classNames={{ "label": "font-semibold" }}
                labelPlacement="outside"
                isClearable={true}
                variant="flat"
                isVirtualized
                defaultItems={
                  unitMaster || []
                }
                onSelectionChange={setSelectedUnit}
                selectedKey={selectedUnit}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              <div className="flex gap-2">
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
              </div>                   

              <Popover placement="bottom" variant="bordered"
                //isDismissable={false}
                shouldCloseOnBlur={false}
                shouldBlockScroll={true}
                shouldCloseOnScroll={false}
                showArrow={true}>
                <PopoverTrigger>
                  <Button size="sm"
                    className="bg-sky-200  text-md border-2 border-sky-500 text-sky-600 px-1" isIconOnly={true}   >
                    <FontAwesomeIcon className="text-xl" icon={faCalendarDays}></FontAwesomeIcon>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="z-[1000]">
                  <div
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                   
                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                      <div className={`flex  gap-2 `}>

                        <div className="relative">
                          <input
                            type="date"
                            name="start"
                            value={filterDate.start}
                            onChange={handleChange}
                            required
                            className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                        <div className="relative">
                          <input
                            type="date"
                            name="end"
                            value={filterDate.end}
                            onChange={handleChange}
                            required
                            className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                      </div>
                      <div className={`flex  gap-2 `}>
                        <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" onPress={handleBtnClick} >Apply</Button>
                        <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                      </div>
                    </div>
                   
                  </div>
                </PopoverContent>
              </Popover>

            </div>
          }

        </div> */}
        <div className="flex w-full flex-col">
          {/* <Temp/>  */}



          <Tabs aria-label="Dynamic tabs" color="primary" items={tabs} radius="none" className="font-semibold  text-sm"
            onSelectionChange={handleTabChange}
            defaultSelectedKey={(outPData && outPData.isFromDashboard) || (outRData && outRData?.isFromDashboard) ||
              (isRedFrmDsbMst && (isRedFrmDsbMst == ENUM_ENCRYPT_CODE.receivable ||
                isRedFrmDsbMst == ENUM_ENCRYPT_CODE.payable)
              ) ? "outstanding"
              : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.sale ? "sale"
                : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.purchase ? "purchase"
                  : ""}
            classNames={{
              base: "max-w-fit",

              tabList:
                "gap-1.5 p-1.5 rounded-xl " +
                "bg-sky-50 dark:bg-sky-950/40 " +
                "border border-sky-200 dark:border-sky-800 " +
                "shadow-sm",

              tab:
                "h-8 px-3 rounded-lg " +
                "text-sky-800/70 dark:text-sky-300/70 " +
                "font-medium " +
                "hover:bg-white hover:text-sky-900 " +
                "dark:hover:bg-sky-900/60 dark:hover:text-sky-100 " +
                "transition-all duration-200",

              tabContent:
                "group-data-[selected=true]:text-white  " +
                "group-data-[selected=true]:font-semibold uppercase",

              cursor:
                "rounded-lg " +
                "bg-gradient-to-r from-sky-900 to-sky-700 " +
                "shadow-md shadow-sky-900/20",

              panel: "pt-5",
            }}

          >
            {(item) => (
              <Tab className="text-sm p-2" key={item.id} title={item.label}   >

                {item.content}

              </Tab>
            )}
          </Tabs>

        </div>
      </MainContainer>
    </div>
  )
}
export default Dashboard
